/**
 * @file Renders its children in bold text.
 */
import React from "react";
import { Typography } from "antd";
import type { ReactNode } from "react";

const { Text } = Typography;

type Props = {
  children: ReactNode;
};

/**
 * Renders its children in bold text.
 */
const Bold = ({ children }: Props): JSX.Element => {
  return (
    <Text strong>{children}</Text>
  );
};

export default Bold;
